//@flow
import React from "react"
import Loader from "../Loader"
import DropTarget from "./DropTarget"
import DropPrompt from "./DropPrompt"
import ImagePreview from "./ImagePreview"
import withFileDrop from "./withFileDrop"

import type { UploadComponentProps, FileDropOnDropFunction } from "./types"

class FileUploader extends React.Component<UploadComponentProps> {
  renderFileDetails = ({ files }: { files: Array<File> }): string => {
    return files[0]
      ? `File: ${files[0].name} | Type: ${files[0].type} | Size: ${files[0]
          .size}`
      : ""
  }

  render() {
    const {
      filePreviews,
      setDropTarget,
      loading,
      errorMessage,
      existingAssetURL
    } = this.props
    const firstPreview = (filePreviews && filePreviews[0]) || existingAssetURL
    return (
      <DropTarget innerRef={el => setDropTarget(el)}>
        {errorMessage ? (
          errorMessage
        ) : (
          <Loader loading={loading || false}>
            {firstPreview ? (
              <ImagePreview src={firstPreview} alt="Preview" />
            ) : (
              <span />
            )}
            <DropPrompt>Drop Any File to Update</DropPrompt>
          </Loader>
        )}
      </DropTarget>
    )
  }
}

export type { FileDropOnDropFunction }

export default withFileDrop(FileUploader)



// WEBPACK FOOTER //
// ./src/UI/FileUploader/index.js